import React from 'react';
import { Link } from 'react-router';
import { getUrl } from 'src/components/ProductDetail/utils/getUrl';
import Bugsnag from '@bugsnag/js';
import { toNotifiableError } from 'src/util/general';

import classes from './BrandLogoLink.scss';

type Props = {
    wrapperClassName?: string;
    brandLink: string;
    brandName: string;
    brandImage: string;
};

export const BrandLogoLink: React.FC<Props> = ({ wrapperClassName, brandLink, brandName, brandImage }) => {
    let image;

    try {
        image = require(`../../../static/img-brands/Logos/${getUrl(brandImage)}`);
    } catch (err) {
        Bugsnag.notify(toNotifiableError(err));
        image = null;
    }

    return (
        <Link to={brandLink} className={wrapperClassName}>
            {image ? (
                <img className={classes.logo} src={image} alt={brandName} />
            ) : (
                <p className={classes.onlyText}>{brandName}</p>
            )}
        </Link>
    );
};
